import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ModalInterface } from '../../models/components-general/modal-genearal.model';

@Component({
  selector: 'app-modal-general',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './modal-general.component.html',
  styleUrl: './modal-general.component.scss',
})
export class ModalGeneralComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalGeneralComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalInterface,
  ) {}

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  public newTableModal(): void {
    this.dialogRef.close(this.data.data);
  }

  public cancelModal(): void {
    this.dialogRef.close(false);
  }
}
